
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus-boxed': {
    width: 21.5,
    height: 21.5,
    viewBox: '0 0 21.5 21.5',
    data: '<path pid="0" d="M4.65 21.451c-2.5 0-4.6-2.1-4.6-4.6v-12.2c0-1.2.5-2.4 1.3-3.3s2-1.4 3.3-1.4h12.2c1.2 0 2.4.5 3.3 1.3.9.9 1.4 2 1.4 3.3v12.2c0 2.6-2.1 4.6-4.6 4.7H4.65zm12.2-20H4.65c-1.8 0-3.2 1.4-3.2 3.2v12.2c0 1.8 1.5 3.1 3.2 3.2h12.2c1.7 0 3.1-1.4 3.2-3.2v-12.2c0-.9-.3-1.7-.9-2.2-.7-.6-1.5-1-2.3-1z"/><path pid="1" d="M15.85 10.138h-4.5v-4.6c0-.3-.3-.6-.6-.6h-.1c-.3 0-.6.3-.6.6v4.6h-4.5c-.3 0-.6.3-.6.6v.1c0 .3.3.6.6.6h4.6v4.5c0 .3.3.6.6.6h.1c.3 0 .5-.2.6-.6v-4.5h4.5c.3 0 .6-.3.6-.6v-.1c-.1-.4-.3-.6-.7-.6z"/>'
  }
})
